<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 26a1.5 1.5 0 01-1.5-1.5V24a4.84 4.84 0 012.81-4.32 3 3 0 00.79-4.8A3 3 0 0024 14a3 3 0 00-3 3 1.5 1.5 0 01-3 0 6 6 0 016-6 6.08 6.08 0 016 6 6 6 0 01-3.37 5.4A1.83 1.83 0 0025.5 24v.5A1.5 1.5 0 0124 26z"/><rect x="22.5" y="27.92" width="3" height="3" rx="1.5"/><path d="M41 7v28H26l-.78.58L19 40v-5.08H7V7h34m1-3H6a2 2 0 00-2 2v30a2 2 0 002 2h10v4a2 2 0 002 2 2 2 0 001.17-.39L27 37.92h15a2 2 0 002-2V6a2 2 0 00-2-2z"/></svg>